import { render } from "./MoveSuccessModal.vue?vue&type=template&id=189a824f&scoped=true"
import script from "./MoveSuccessModal.vue?vue&type=script&lang=js"
export * from "./MoveSuccessModal.vue?vue&type=script&lang=js"

import "./MoveSuccessModal.vue?vue&type=style&index=0&id=189a824f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189a824f"]])

export default __exports__